import React from 'react';
import './CardSection.css';
import Card from '../card/Card.js';


const CardSection = ({day, section}) => {

    const cards = section.cards.map((c,i) => {
        return <Card key={i+c.title} day={day} title={c.title} filter={c.filter}/>
    });
    return (
    <div >
        <div className='card_section_title'>{section.title}</div>
        <div className='cards'>
            {cards}
        </div>

    </div>
    )
    ;
}

export default CardSection;